<template>
	<div v-if="randCliData">
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox float-e-margins">
						<div class="ibox-title">
							<h4>
								Random Cli settings:
							</h4>
						</div>
						<div class="ibox-content">

							<div class="row">
								<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<form name="editCRMUserForm" novalidate="" class="" @submit.prevent="save()"
										v-if="!loading">

										<div class="row form-group topZindex">
											<span
												class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label importantColor">*Main:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
												<b-dropdown id="dropdown-1" :text=randCliData.cidInText class="my-class">
													<b-dropdown-item v-for="numberData in numbersData"
														:key=numberData.number
														@click="randCliData = { ...randCliData, cid_in: numberData.number,cidInText: numberData.display }; cidOutList = [];">
														{{ numberData.display }}
													</b-dropdown-item>
												</b-dropdown>
											</div>
										</div>

										<div class="row form-group middleZindx">
											<span
												class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor ">*Random:</span>
											<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
												<b-dropdown id="dropdown-1" :text=randCliData.cidOutText class="my-class">
													<b-dropdown-item v-for="numberData in numbersData"
														:key=numberData.number
														@click="randCliData = { ...randCliData, cid_out: numberData.number, cidOutText:  numberData.display }">
														{{ numberData.display }}
													</b-dropdown-item>
												</b-dropdown>
												<button class="btn btn-sm btn-success ml-4 btn-width"
													@click.prevent="addCidOut()">Add</button>
											</div>
										</div>

										<div class="row form-group behindZindex">
											<div class="outNumberContainer" v-for="number in cidOutList" :key="number">
												<p>{{ numbersData.find(n => n.number === number) ? numbersData.find(n => n.number === number).display : number }}</p>
												<button class="btn btn-sm btn-success ml-2 btn-width"
													@click.prevent="cidOutList = cidOutList.filter(c => c != number)">Remove</button>
											</div>
										</div>

										<hr>
										<div class="row submit-button-container behindZindex">
											<button type="submit" :disabled="sendInProgress || cidOutList.length === 0"
												ref="submitbtn"
												class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt"
												data-style="zoom-out" data-spinner-size="24" data-size="s"
												data-spinner-color="white" style="display: block;">
												<span class="ladda-label">Save</span>
												<span class="fas fa-spinner fa-pulse"></span>
												<div class="ladda-progress" style="width: 0px"></div>

											</button>
										</div>
									</form>
								</div>
							</div>
							<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ng-scope" style="margin-bottom: 8px;"
								ng-if="options.showProgress">
								<div v-if="loading" class="sk-spinner sk-spinner-wave ng-scope"
									ng-if="options.showProgress" style="display: block;">
									<div class="sk-rect1"></div>
									<div class="sk-rect2"></div>
									<div class="sk-rect3"></div>
									<div class="sk-rect4"></div>
									<div class="sk-rect5"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {RandomCliApiService} from "../../services/RandomCliApiService";
import {NumbersApiService} from "../../services/NumbersApiService";
export default {
	props: ["routeData"],
	data: () => ({
		loading: false,
		randCliData: {},
		sendInProgress: false,
		numbersData: [],
		cidOutList: []
	}),
	created() {
		let $injector = this.$root.angularInjector;

		let CoreApiService = $injector.get("CoreApiService");

		this.RandomCliApiService = new RandomCliApiService(CoreApiService);
		this.NumbersApiService = new NumbersApiService(CoreApiService);

		this.SwalService = $injector.get("SwalService");
	},
	async mounted() {
		this.loading = true;
		this.numbersData = await this.NumbersApiService.list();
		this.items = await this.RandomCliApiService.list();
		this.randCliData = {};
		this.loading = false;
	},
	watch: {
		sendInProgress: function(val) {
			if (val) {
				this.$refs.submitbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.submitbtn.dataset.loading;
			}
		}
	},
	methods: {
		addCidOut() {
			if (!this.randCliData.cid_out) {
				this.SwalService.popup({
					title: "Please choose main and random numbers.", type: "error"
				});
				return;
			}
			if (!this.cidOutList.includes(this.randCliData.cid_out)) {
				if (!this.isAlreadyExistInRandCli(this.randCliData.cid_in, this.randCliData.cid_out)) {
					this.cidOutList.push(this.randCliData.cid_out);
					this.randCliData.cidOutText = "";
					this.randCliData.cid_out = null;
				}
				else {
					this.SwalService.popup({
						title: "Current random cli already exist, please choose another one to add.", type: "error"
					});
				}
			}
			else {
				this.SwalService.popup({
					title: "Already in list!", type: "error"
				});
			}
		},
		formatNumber(/** @type {string} */ number) {
			return number.length <= 10 && number.charAt(0) == "0"
				? "972" + number.substring(1) : number.startsWith("00")
					? number.substring(2) : number;
		},
		isAlreadyExistInRandCli(inNumber, outNumber) {
			for (const nData of this.items) {
				const inFormmated = this.formatNumber(inNumber);
				const outFormmated = this.formatNumber(outNumber);
				if (inFormmated === nData.cid_in && outFormmated === nData.cid_out) {
					return true;
				}
			}
			return false;
		},
		async save() {
			this.sendInProgress = true;
			try {
				let promises = [];
				for (const outNumber of this.cidOutList) {
					// console.log(outNumber);
					// console.log(this.randCliData);
					promises.push(this.RandomCliApiService.create({...this.randCliData, cid_out: outNumber}));
				}
				await Promise.all(promises);
				this.SwalService.popup({
					title: "Success!"
				}).then(f => {
					this.$router.replace("/list");
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: getErrorMessage(e), type: "error"
				});
			}
			finally {
				this.sendInProgress = false;
			}
		}
	}
};

function getErrorMessage(e) {
	if (e.message == "Bad request") {
		if (e.key == "error_username_in_use") {
			return "Duplicate username";
		}
		else if (e.key == "error_email_exists") {
			return "Duplicate email";
		}
	}
	return e.message || e.statusText || e || "Error";
}
</script>

<style lang="scss" scoped>
.importantColor {
	color: #732;
	font-weight: bold;
	padding: 5px;
}

.my-class /deep/ .dropdown-menu {
	max-height: 240px;
	overflow-y: auto;
	transform: unset !important;
	left: 0%;
}

.my-class /deep/ a {
	padding: 1px !important;
	margin: 1px !important;
	line-height: 20px !important;
}

.ibox-content /deep/ ul {
	width: 250px !important;
}

.behindZindex {
	z-index: 0 !important;
}

.middleZindx {
	z-index: 3 !important;
}

.topZindex {
	z-index: 5 !important;
}

.btn-width {
	width: 10% !important;
}

.outNumberContainer {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;

	p {
		width: 50%;
		text-align: right;
		align-self: end;
	}

	button {
		max-width: 80px;
	}
}
</style>>
